import Plyr from 'plyr';

export default () => {
  const video_players = document.querySelectorAll('.js-video-player');
  if (video_players) {
    video_players.forEach(element => {
      new Plyr(element, {
        autoplay: true,
        controls: false,
        muted: true,
        ratio: false,
        loop: {
          active: true,
        },
      })
    });
  }
}